import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import React from "react";
import CustomButton from "../Components/Button";
import {
  returnMaterialData,
  updateMaterialReturnableStatus,
} from "./mutations/returnbleMaterial";
import { useMutation, useQuery, useQueryClient } from "react-query";
import useAuth from "../../hooks/useAuth";
import { formatDate, formatTime } from "../../utils/formatDate";
import { handleToastMsg } from "../Components/Toast";
import Loader from "../Components/Loader";

function MaterialReturnable() {
  const { mutate: statusMutate, isLoading: statusLoader } = useMutation(
    updateMaterialReturnableStatus
  );
  const queryClient = useQueryClient();
  const { auth } = useAuth();
  const { data: materialData } = useQuery(
    "get-returnable",
    () => returnMaterialData(),
    {
      onSuccess: (res) => {
        console.log({ res });
      },
      refetchOnMount: true,
    }
  );

  const updateStatus = (id) => {
    statusMutate(id, {
      onSuccess: (res) => {
        console.log({ res });
        queryClient.invalidateQueries("get-returnable");
        handleToastMsg("Data updated successfully", "success");
      },
    });
  };

  const isManagingDirector = auth?.roles.includes("MANAGING DIRECTOR");

  if (statusLoader) return <Loader />;

  return (
    <Grid container justifyContent={"center"}>
      <h4 style={{ textAlign: "center" }}>
        Materials Returnable / திரும்பப் பெறக்கூடிய பொருள்
      </h4>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell align="center">Date / தேதி</TableCell>
            <TableCell>Gate Pass No / குறிப்பு எண்</TableCell>
            <TableCell>Out time / வெளியேறும் நேரம்</TableCell>
            <TableCell align="right"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {materialData && materialData.length > 0 ? (
            materialData.map((row) => (
              <TableRow
                key={row.id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell align="center">{formatDate(row.outDate)}</TableCell>
                <TableCell component="th" scope="row" align="center">
                  {row.gatePassNum}
                </TableCell>
                <TableCell component="th" scope="row">
                  {formatTime(row.outTime)}
                </TableCell>
                <TableCell align="right">
                  {!isManagingDirector && (
                    <CustomButton onClick={() => updateStatus(row.id)}>
                      Returned / பெறப்பட்டது
                    </CustomButton>
                  )}
                </TableCell>
              </TableRow>
            ))
          ) : (
            <h4>No data found</h4>
          )}
        </TableBody>
      </Table>
    </Grid>
  );
}

export default MaterialReturnable;
